@if(data.type === 'product'){
  <h2 mat-dialog-title class="font-serif">{{ data.title }}</h2>
} @else {
  <h2 mat-dialog-title class="font-serif">{{ data.name }}</h2>
}
<mat-dialog-content>
  @if(data.type === 'product'){
    <p>
      <span>Name: {{ data.title }}</span><br>
      <span>Type: {{ data.type }}</span>
    </p>
  } @else {
    <p>
      <span>Symbol: {{ data.symbol }}</span><br>
      <span>Name: {{ data.name }}</span><br>
      <span>Exchange: {{ data.exchange }}</span><br>
      <span>Asset Type: {{ data.assetType }}</span><br>
      <span>IPO Date: {{ data.ipoDate }}</span><br>
      <span>DelistingDate: {{ data.delistingDate }}</span><br>
      <span>Status: {{ data.status }}</span>
    </p>
  }

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button class="bp-button" (click)="onNoClick()">{{ 'ACTIONS.cancel' | translate }}</button>
  <button mat-flat-button class="bp-button" [mat-dialog-close]="data" cdkFocusInitial>{{ 'ACTIONS.add' | translate }}</button>
</mat-dialog-actions>
